import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
  Checkbox,
  IconButton,
  Menu
} from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import Chip from '@mui/material/Chip';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { useEffect, useState } from "react";
import { cpfMask } from "utils/cpf";
import { ICampanhaResumo } from "../types";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Padding } from "@mui/icons-material";

dayjs.extend(utc)

interface IFilters {
    nomeCpf: string,
    parentesco: 'Todos' | 'Titular' | 'Dependente',
    tipoCampanhas: 'Todos' | 'Retificações' | 'Beneficiários' | 'Documentos',
    status: 'Todos' | 'Concluída' | 'Pendente',
}
interface MenuState {
  anchorEl: null | HTMLElement;
  cpf: null | string;
}

function formatDate(dateToFormat: string) {
  try {
    if (!dayjs(dateToFormat).isValid()) throw new Error();
    
    return dayjs(dateToFormat).utc().format(`DD/MM/YYYY`);
  } catch (error) {
    return `-`
  }
}

export function ResumoTable({ data: xxAllDataB, active = false }: { data: ICampanhaResumo['result'], active?: boolean }) {
  const [xxAllDataz, setXxAllData] = useState<ICampanhaResumo['result']>(xxAllDataB);

  const [menuState, setMenuState] = useState<MenuState>({ anchorEl: null, cpf: null });
  const open = Boolean(menuState.anchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>, cpf: string) => {
    setMenuState({ anchorEl: event.currentTarget, cpf: cpf });
  };

  const handleCloseMenu = () => {
    setMenuState({ anchorEl: null, cpf: null });
  };

  const handleEstenderCampanha = () => {
    console.log("Estender campanha para o CPF:", menuState.cpf);
    handleCloseMenu();
  };

  const handleCopiarLink = () => {
    console.log("Copiar link para o CPF:", menuState.cpf);
    handleCloseMenu();
  };


  const xxAllFilters: IFilters = {
      nomeCpf: '',
      parentesco: 'Todos',
      tipoCampanhas: 'Todos',
      status: 'Todos',
    }
    const [xxCurrentData, setXxCurrentData] = useState<ICampanhaResumo['result']>(xxAllDataz);
    const [xxCurrentFilters, setXxCurrentFilters] = useState(xxAllFilters);

    useEffect(() => {
      setXxAllData([...xxAllDataB]);
      setXxCurrentData([...xxAllDataB]);
    }, [xxAllDataB])
  
    const [order, setOrder] = useState<'asc' | 'desc'>('asc');
    const [orderBy, setOrderBy] = useState<string>('nome');
  
    const parentescoOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.parentesco))];
    const tipoCampanhasOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.tipoCampanhas))];
    const statusOptions = ['Todos', ...new Set(xxAllDataz.map(item => item.status))];
  
    function handleFilters(filters: IFilters) {
      setXxCurrentFilters({ ...filters });
    }
  
    const handleSort = (property: string) => {
      const isAsc = order === 'asc'; 
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    useEffect(() => {
      const filteredData = xxAllDataz.filter(data => {
        const shouldDisplayName = data?.nome?.toLocaleLowerCase()?.includes(xxCurrentFilters.nomeCpf.toLocaleLowerCase()) || data?.cpf?.includes(xxCurrentFilters.nomeCpf);
        const shouldDisplayParentesco = xxCurrentFilters.parentesco === 'Todos' || xxCurrentFilters.parentesco === data.parentesco;
        const shouldDisplayTipoCampanhas =
          xxCurrentFilters.tipoCampanhas === 'Todos' ||
          data.tipoCampanhas.includes(xxCurrentFilters.tipoCampanhas);
        const shouldDisplayStatus = xxCurrentFilters.status === 'Todos' || xxCurrentFilters.status === data.status;
  
        return shouldDisplayName && shouldDisplayParentesco && shouldDisplayTipoCampanhas && shouldDisplayStatus;
      });
      const sortedData = filteredData.sort((a, b) => {
        if (orderBy === 'nome') {
          const aValue = a.nome.toLowerCase();
          const bValue = b.nome.toLowerCase();
          if (aValue < bValue) return order === 'asc' ? -1 : 1;
          if (aValue > bValue) return order === 'asc' ? 1 : -1;
          return 0;
        }

        if (orderBy === 'dataEnvio') {
          const aDate = new Date(a.dataEnvio).getTime();
          const bDate = new Date(b.dataEnvio).getTime();
          return order === 'asc' ? aDate - bDate : bDate - aDate;
        }

        if (a.parentesco < b.parentesco) return order === 'asc' ? -1 : 1;
        if (a.parentesco > b.parentesco) return order === 'asc' ? 1 : -1;
        return 0;
      });
      setXxCurrentData([ ...sortedData ]);
    }, [xxCurrentFilters, order, orderBy]);
  
    return (
      <>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <TextField
            fullWidth
            label='Nome beneficiário ou CPF'
            placeholder='Digite para pesquisar'
            variant='outlined'
            value={xxCurrentFilters.nomeCpf}
            onChange={(e) => handleFilters({ ...xxCurrentFilters, nomeCpf: e.target.value  })}
            InputProps={{ 
              startAdornment: (
                <InputAdornment position='start'>
                  <SearchIcon color='action' style={{ width: '24px', aspectRatio: '1' }}/>
                </InputAdornment>
              )
            }}
          />
          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '8px', alignItems: 'center', marginBottom: '24px' }}>
            <Typography color='gray' variant='body2'>Filtrar por</Typography>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="parentesco">Plano</InputLabel>
              <Select
                labelId="parentesco"
                label="Parentesco"
                value={xxCurrentFilters.parentesco}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, parentesco: e.target.value  })}
                style={{ height: '40px' }}
              >
                {parentescoOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="tipoCampanhas">Tipo</InputLabel>
              <Select
                labelId="tipoCampanhas"
                label="Tipo de campanhas"
                value={xxCurrentFilters.tipoCampanhas}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, tipoCampanhas: e.target.value  })}
                style={{ height: '40px' }}
              >
                {tipoCampanhasOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ width: '165px' }}>
              <InputLabel id="status">Situação</InputLabel>
              <Select
                labelId="status"
                label="Status"
                value={xxCurrentFilters.status}
                defaultValue={'Todos'}
                //@ts-ignore
                onChange={(e) => handleFilters({ ...xxCurrentFilters, status: e.target.value  })}
                style={{ height: '40px' }}
              >
                {statusOptions.map(option => (
                  <MenuItem value={option}>{option}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button onClick={() => handleFilters({ nomeCpf: '', tipoCampanhas: 'Todos', status: 'Todos', parentesco: 'Todos' })}>Limpar filtro</Button>
          </div>
        </div>
        {active ? (
          <TableContainer
            sx={{
              "& .MuiTableCell-root": {
                background: "#FFFFFF !important",
              },
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>   
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'nome'}
                        direction={orderBy === 'nome' ? order : 'asc'}
                        onClick={() => handleSort('nome')}
                      >
                      Nome Beneficiário
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'cpf'}
                        direction={orderBy === 'cpf' ? order : 'asc'}
                        onClick={() => handleSort('cpf')}
                      >
                      CPF/CNPJ
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'parentesco'}
                        direction={orderBy === 'parentesco' ? order : 'asc'}
                        onClick={() => handleSort('parentesco')}
                      >
                      Parentesco
                    </TableSortLabel>
                  </TableCell>
                  {/* <TableCell>
                    <TableSortLabel
                        active={orderBy === 'tipoCampanhas'}
                        direction={orderBy === 'tipoCampanhas' ? order : 'asc'}
                        onClick={() => handleSort('tipoCampanhas')}
                      >
                      Código Beneficiário
                    </TableSortLabel>
                  </TableCell> */}
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'dataEnvio'}
                        direction={orderBy === 'dataEnvio' ? order : 'asc'}
                        onClick={() => handleSort('dataEnvio')}
                      >
                      Data de Envio
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'dataAbertura'}
                        direction={orderBy === 'dataAbertura' ? order : 'asc'}
                        onClick={() => handleSort('dataAbertura')}
                      >
                      Data de abertura
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'dataConclusao'}
                        direction={orderBy === 'dataConclusao' ? order : 'asc'}
                        onClick={() => handleSort('dataConclusao')}
                      >
                      Data de conclusão
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                        active={orderBy === 'status'}
                        direction={orderBy === 'status' ? order : 'asc'}
                        onClick={() => handleSort('status')}
                      >
                      Status
                    </TableSortLabel>
                  </TableCell>                
                </TableRow>
              </TableHead>
              <TableBody>
                {xxCurrentData.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.nome}
                      </div>
                    </TableCell>                 
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {Number(row.cpf) ? cpfMask(row.cpf) : row.cpf}
                      </div>
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.parentesco}
                      </div>
                    </TableCell>                  
                    {/* <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {row.tipoCampanhas.join(', ')}
                      </div>
                    </TableCell> */}
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {!row?.dataEnvio ? "-" : formatDate(row.dataEnvio)}
                      </div>  
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {!row?.dataAbertura ? "-" : formatDate(row.dataAbertura)}
                      </div>  
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {!row?.dataConclusao ? "-" : formatDate(row.dataConclusao)}
                      </div>  
                    </TableCell>
                    <TableCell>
                      <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      <Chip
                        label={row.status}
                        size="small"
                        variant="filled"
                        color="default"    
                        style={{
                          color: row.status === 'Concluída' ? '#2E7D32' : '#EF6C00',
                          fontSize: '12px',
                        }}                    
                      />
                      </div>
                    </TableCell>
                    <TableCell align="right">                      
                      <IconButton 
                        size="small"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={(e) => handleClickMenu(e, row.cpf)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>            
            <Menu
              id="basic-menu"
              anchorEl={menuState.anchorEl}
              open={open}
              onClose={handleCloseMenu}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              slotProps={{
                paper: {
                  sx: {
                    borderRadius: '0.5rem',
                    boxShadow: 3,
                    border: 'none',
                  },
                },
              }}
            >
              {/* <MenuItem onClick={handleEstenderCampanha}>Estender campanha</MenuItem> */}
              <MenuItem onClick={handleCopiarLink}>Copiar link</MenuItem>              
            </Menu>
          </TableContainer>
        ) : (
          <>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '24px', padding: '0 0 24px 0' }}>
              
            </div>
            <Typography style={{"padding":"0","margin":"0","fontSize":"1.25rem","lineHeight":"1.75rem","fontWeight":600}}>Nenhum arquivo foi carregado até o momento.</Typography>
            <Typography variant="body2" color="textSecondary">No botão “Atualizar fonte de dados” faça o carregamento do arquivo necessario.</Typography>
          </div>
          </>
        )}
      </>
    );
}